import { Outlet } from 'react-router';
import { Topbar } from '../../components/app-shell';

export function AppLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Topbar />
      <main className="flex-1">
        <div className="mx-auto max-w-[1400px] px-4 lg:px-8">
          <div className="py-6">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
}